import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { Link } from '../../../../../../Resource/Types';
import ProportionalImage from '../ProportionalImage';
import { findLinkByR } from '../../../../../../Links';

export interface SchoolPartnerLogoProps {
  links: ReadonlyArray<Link>;
  height: number;
  name: string;
  className?: string;
}

function SchoolPartnerLogo({ links, height, name, className }: SchoolPartnerLogoProps) {
  return findLinkByR({ rel: 'logo-on-white' }, links)
    .map(({ href }) => (
      <ProportionalImage href={href} alt={name} height={height} className={className} />
    ))
    .getOrElse(emptyFragment);
}

export default observer(SchoolPartnerLogo);
